import type { ModuleManifest } from "./types";

export const threatsMeasuresManifest: ModuleManifest = {
  name: "threats-measures",
  label: "Minaccia-Misura",
  labelPlural: "Minacce-Misure",
  coreBOSModule: "ThreatsMeasures",
  wsidPrefix: "68x",
  type: "standard",
  routes: {
    list: "/threats-measures",
    show: "/threats-measures/show/:id",
    create: "/threats-measures/create",
    edit: "/threats-measures/edit/:id",
  },
  navigation: {
    icon: "SafetyCertificateOutlined",
    order: 12,
    group: "Security",
    hidden: false,
  },
  routing: {
    keywords: ["threatsmeasures", "minacce-misure", "mapping"],
    searchFields: ["threatsmeasuresname"],
    defaultSort: { field: "threatsmeasuresname", order: "asc" },
  },
  context: { supported: false, entityKey: "threats-measures" },
  fields: [
    { name: "threatsmeasuresname", label: "Nome", type: "string", required: true },
    { name: "threat_link", label: "Minaccia", type: "reference" },
    { name: "measure_id", label: "Misura", type: "string" },
    { name: "measure_name", label: "Nome Misura", type: "string" },
    { name: "implementation_status", label: "Stato", type: "picklist", options: [
      { value: "TBD", label: "Da valutare" },
      { value: "In_Progress", label: "In corso" },
      { value: "Implemented", label: "Implementata" },
    ]},
    { name: "critical_gap_score", label: "Gap Score", type: "number" },
    { name: "task_layer", label: "Layer", type: "picklist", options: [
      { value: "BASELINE", label: "Baseline" },
      { value: "ENHANCEMENT", label: "Enhancement" },
    ]},
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Threats", field: "threat_link", label: "Minaccia", icon: "AppstoreOutlined", displayField: "threatname" },
  ],
  requiredFields: ["threatsmeasuresname"],
  viewStrategy: "bespoke",
};
